import type { ExtractionErrorCode } from "./types";

export class FileExtractionError extends Error {
  code: ExtractionErrorCode;
  fileName: string;
  details?: string;

  constructor(params: {
    code: ExtractionErrorCode;
    fileName: string;
    message: string;
    details?: string;
  }) {
    super(params.message);
    this.name = "FileExtractionError";
    this.code = params.code;
    this.fileName = params.fileName;
    this.details = params.details;
  }
}

export class VersionMismatchError extends FileExtractionError {
  expectedVersions: string[];
  actualVersion: string | null;

  constructor(params: {
    fileName: string;
    expectedVersions: string[];
    actualVersion: string | null;
  }) {
    super({
      code: "VERSION_MISMATCH",
      fileName: params.fileName,
      message: `Version mismatch in ${params.fileName}: expected one of [${params.expectedVersions.join(", ")}], got "${params.actualVersion}"`,
    });
    this.name = "VersionMismatchError";
    this.expectedVersions = params.expectedVersions;
    this.actualVersion = params.actualVersion;
  }
}
